import React from 'react';
import GxForm from '../../gx/GxForm';
import * as FxLog from '../../fx/FxLog';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import { StorePs } from "../../gx/GxStore";
import CxImageEditor from '../../cx/CxImageEditor';
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxPsPhotoForm = (props) => {
  const [{ trans }] = useTranslation();

  const [storePs, ] = useSessionStorage('StorePs', StorePs);
  
  const rf_image = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onSelect = () => {
    // se guardó exitosamente
    FxLog.infox('MxPsPhotoForm.onSelect', '...', );
    rf_image.current.doSave(storePs.inPs);
  }
  const onClear = () => {
    // se guardó exitosamente
    FxLog.infox('MxPsPhotoForm.onClear', '...', );
    rf_image.current.doDelete(storePs.inPs);
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.photo')}`}
      >
        <CxImageEditor xref={rf_image} 
          url='ps/photo' 
          inXXX={storePs.inPs} 
          can_search 
          onSelect={onSelect} 
          onClear={onClear} 
          />

      </GxForm>

    </div>
  );

}

export default MxPsPhotoForm;
